"use client";
import { ChevronsUpDownIcon } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { useFile } from "@/hooks/use-file";
import { cn, getFullName, getInitials } from "@/lib/utils";
import { useSession } from "@/providers/session-provider";
import {
	ProfileDropdownHelpButton,
	ProfileDropdownLogoutButton,
	ProfileDropdownSettingsButton,
} from "../ProfileDropdown/profile-dropdown-buttons";
import { ProfileDropdownLanguage } from "../ProfileDropdown/profile-dropdown-language";
import { ThemeSwitch } from "../ProfileDropdown/profile-dropdown-themes";

export function SidebarProfileMenu() {
	const session = useSession();
	const { getUrl } = useFile();

	const photoUrl = getUrl({
		collectionName: "Doctors",
		id: session?.id,
		filename: session?.photo,
	});

	const fullName = getFullName(session);

	// TODO: Validate keyboard shortcuts
	return (
		<SidebarMenu>
			<SidebarMenuItem>
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<SidebarMenuButton
							className={cn(
								"relative",
								"cursor-pointer",
								"data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
							)}
							size="lg"
						>
							<Avatar className="size-8 rounded-lg">
								<AvatarImage alt={fullName} src={photoUrl} />
								<AvatarFallback className="rounded-lg">{getInitials(fullName)}</AvatarFallback>
							</Avatar>

							<div className="grid flex-1 text-left text-sm/tight">
								<span className="truncate font-semibold">{fullName}</span>
								<span className="truncate text-xs">{session?.email}</span>
							</div>
							<ChevronsUpDownIcon className="ml-auto size-4" />
						</SidebarMenuButton>
					</DropdownMenuTrigger>

					<DropdownMenuContent
						align="end"
						className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
						side={"bottom"}
						sideOffset={4}
					>
						<DropdownMenuGroup>
							<ThemeSwitch />

							<DropdownMenuSeparator />

							<ProfileDropdownLanguage />

							<ProfileDropdownSettingsButton />

							<ProfileDropdownHelpButton />
						</DropdownMenuGroup>

						<DropdownMenuSeparator />

						<ProfileDropdownLogoutButton />
					</DropdownMenuContent>
				</DropdownMenu>
			</SidebarMenuItem>
		</SidebarMenu>
	);
}
